import { t } from '@/hooks/web/useI18n';
import { Layout } from '@/utils/routerHelper';

export const merchantRoutes: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    name: 'Dashboard',
    meta: {
      title: t('router.dashboard'),
      icon: 'ant-design:dashboard-filled'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Dashboard/Index.vue'),
        name: 'Analysis',
        meta: {
          title: t('router.dashboard'),
          icon: 'ant-design:dashboard-filled',
          noCache: true,
          affix: true
        }
      }
    ]
  },
  {
    path: '/orders',
    component: Layout,
    name: 'Orders',
    meta: {
      title: t('router.orders'),
      icon: 'bitcoin-icons:transactions-outline'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Orders/Index.vue'),
        name: 'OrderList',
        meta: {
          title: t('router.orders'),
          icon: 'mdi:instant-deposit'
        }
      },
      {
        path: ':id',
        component: () => import('@/views/Orders/Detail.vue'),
        name: 'OrderDetail',
        meta: {
          title: t('router.orderDetails'),
          activeMenu: '/orders',
          hidden: true
        }
      }
    ]
  },
  // {
  //   path: '/balances',
  //   component: Layout,
  //   name: 'Balance',
  //   meta: {
  //     title: t('router.balances'),
  //     icon: 'ic:twotone-account-balance-wallet'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/Merchant/Balances.vue'),
  //       name: 'MerchantBalances',
  //       meta: {
  //         title: t('router.balances'),
  //         icon: 'ic:twotone-account-balance-wallet'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/payments',
    component: Layout,
    name: 'Payments',
    meta: {
      title: t('router.payments'),
      icon: 'icon-park-outline:payment-method',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Payments/Index.vue'),
        name: 'Payments',
        meta: {
          title: t('router.payments'),
          icon: 'icon-park-outline:payment-method'
        }
      }
    ]
  },
  // {
  //   path: '/reports',
  //   component: Layout,
  //   name: 'Reports',
  //   meta: {
  //     title: t('router.dataStatistics'),
  //     icon: 'ant-design:bar-chart-outlined'
  //   },
  //   children: [
  //     {
  //       path: 'payment-method-order-summary',
  //       component: () => import('@/views/Reports/PaymentOrderSummary.vue'),
  //       name: 'PaymentOrderSummary',
  //       meta: {
  //         title: t('router.paymentMethodOrderSummary'),
  //         icon: 'ant-design:bar-chart-outlined'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/error',
    component: Layout,
    redirect: '/error/404',
    name: 'Error',
    meta: {
      title: t('router.errorPage'),
      icon: 'ci:error',
      hidden: true
    },
    children: [
      {
        path: '404',
        component: () => import('@/views/Error/404.vue'),
        name: '404',
        meta: {
          title: '404'
        }
      },
      {
        path: '403',
        component: () => import('@/views/Error/403.vue'),
        name: '403',
        meta: {
          title: '403'
        }
      },
      {
        path: '500',
        component: () => import('@/views/Error/500.vue'),
        name: '500',
        meta: {
          title: '500'
        }
      }
    ]
  },
  {
    path: '/authorization',
    component: Layout,
    name: 'Authorization',
    meta: {
      title: t('router.authorization'),
      icon: 'eos-icons:role-binding',
      permission: 'manage-user'
    },
    children: [
      {
        path: 'users',
        component: () => import('@/views/Authorization/User/Index.vue'),
        name: 'Users',
        meta: {
          title: t('router.user'),
          icon: 'eos-icons:role-binding',
          permission: 'manage-user'
        },
        children: [
          {
            path: ':id',
            component: () => import('@/views/Authorization/User/Detail.vue'),
            name: 'UserDetail',
            meta: {
              title: t('router.userDetail'),
              hidden: true
            }
          }
        ]
      },
      {
        path: 'role',
        component: () => import('@/views/Authorization/Role/Role.vue'),
        name: 'Role',
        meta: {
          title: t('router.role'),
          icon: 'eos-icons:role-binding',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/merchant-settings',
    component: Layout,
    name: 'MerchantSettings',
    meta: {
      title: t('router.settings'),
      icon: 'ri:settings-5-line'
    },
    children: [
      {
        path: '',
        component: () => import('@/views/Merchant/Merchant.vue'),
        name: 'MerchantSettingsPage',
        meta: {
          title: t('router.merchantSettings'),
          icon: 'ri:settings-5-line'
        }
      }
    ]
  },
]